<div class="admin-homes h-full flex flex-col p-4">
  <div *ngIf="homeTabs.length > 0; else noHomes" class="controls h-full flex flex-col">
    <dx-tab-panel class="h-full">
      <dxi-item *ngFor="let tab of homeTabs" [title]="tab.title">
        <ng-container *ngComponentOutlet="tab.component"></ng-container>
      </dxi-item>
    </dx-tab-panel>
  </div>
  <ng-template #noHomes>
    <p class="text-muted">{{ 'menu.homePage.noHomesConfigured' | translate | ucfirst }}</p>
  </ng-template>
</div>
